import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { InputValidationIcon } from 'libs/forms/styles';
import { StringFieldStore, EditorFieldStore } from 'libs/forms/fieldStores';

const CharCount = styled.span`
  position: absolute;
  top: -20px;
  right: 0;
  color: ${props =>
    props.exact
      ? props.theme.color.primary
      : props.invalid
      ? props.theme.color.wfOrange
      : props.theme.color.wfGrey500};
  font-size: 13px;
`;

@observer
export class Validation extends React.Component {
  render() {
    const { fieldStore, handleClick, positionFixed } = this.props;

    if (!fieldStore.showValidation) {
      const { maxLen } = fieldStore.conf;
      let charCount;
      if (fieldStore instanceof StringFieldStore) {
        charCount = fieldStore?.value?.length || 0;
      }
      if (fieldStore instanceof EditorFieldStore) {
        charCount = fieldStore?.editor?.value?.document?.text?.length || 0;
      }
      const critical = maxLen - 10 <= charCount;
      if (critical) {
        return (
          <CharCount invalid={charCount > maxLen} exact={charCount === maxLen}>
            {charCount} / {maxLen}
          </CharCount>
        );
      }
      return <span></span>;
    }
    if (fieldStore.validity[0] !== false) {
      return (
        <InputValidationIcon
          name='success'
          valid
          positionFixed={positionFixed}
        />
      );
    }
    return (
      <InputValidationIcon
        name='error'
        positionFixed={positionFixed}
        onClick={() => {
          fieldStore.ResetValue();
          handleClick();
        }}
      />
    );
  }
}

Validation.propTypes = {
  fieldStore: PropTypes.object,
  handleClick: PropTypes.func,
  positionFixed: PropTypes.bool,
};
